import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

export function uniqueTasksValidator(): ValidatorFn {
    return (formArray: AbstractControl): { [key: string]: any } | null => {
        if (!(formArray instanceof FormArray)) {
            return null;
        }

        const texts = formArray.controls
            .map((control) => control.value?.trim())
            .filter((text) => text != null || text != '');

        const hasDuplicates = texts.some((text, index) => texts.indexOf(text) !== index);

        return hasDuplicates ? { duplicateText: true } : null;
    };
}
